<template lang="pug">
    .setting(:class="{'setting_wrapped': isLargeCombiningDigitCapacities}")
        .setting__box(v-for='combiningDigitCapacity in filteredCombiningDigitCapacities')
            label.setting__label(:class="settingLabelClasses")
                | {{ combiningDigitCapacityLabels[combiningDigitCapacity] }}
            component.setting__checkbox(
                :class="settingCheckboxClasses"
                :is="innerComponentName"
                :[stateAttributeName]='combiningDigitCapacities.includes(combiningDigitCapacity)'
                :key='combiningDigitCapacityLabels[combiningDigitCapacity]'
                :disabled='combiningDigitCapacities.length === 2 && combiningDigitCapacities.includes(combiningDigitCapacity)'
                @[actionEventName]='changeCombiningDigitCapacities(combiningDigitCapacity)'
            )
</template>

<script>
    const DEFAULT_INNER_COMPONENT = 'cs-checkbox';
    const INDIVIDUAL_SETTINGS_INNER_COMPONENT = 'settings-tab';

    export default {
        props: {
            filteredCombiningDigitCapacities: Array,
            combiningDigitCapacities: Array,
            combiningDigitCapacityLabels: Object,
            innerComponentName: {
                type: String,
                default: DEFAULT_INNER_COMPONENT,
            },
        },
        methods: {
            changeCombiningDigitCapacities(combiningDigitCapacity) {
                this.$emit('changeCombiningDigitCapacities', combiningDigitCapacity);
            },
        },
        computed: {
            stateAttributeName() {
                return this.innerComponentName === DEFAULT_INNER_COMPONENT ? 'checked' : 'selected';
            },
            actionEventName() {
                return this.innerComponentName === DEFAULT_INNER_COMPONENT ? 'change' : 'select';
            },
            isLargeCombiningDigitCapacities() {
                return this.filteredCombiningDigitCapacities && this.filteredCombiningDigitCapacities.length > 5;
            },
            settingLabelClasses() {
                return {
                    setting__label_checkbox: this.innerComponentName === DEFAULT_INNER_COMPONENT,
                };
            },
            settingCheckboxClasses() {
                return {
                    setting__checkbox_flexed: this.isLargeCombiningDigitCapacities,
                    setting__checkbox_tab: this.innerComponentName === INDIVIDUAL_SETTINGS_INNER_COMPONENT,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .setting {
        display: flex;
        flex-direction: column;
        &__checkbox {
            width: 100%;
            &_flexed {
                flex: 1 1 35%;
            }
            &_tab {
                width: 200px;
            }
        }
    }
    .setting_wrapped {
        flex-wrap: wrap;
    }
    .setting__label {
        width: 100%;
        margin: 0 0 10px 0;
        text-align: left;
        @include media($md) {
            text-align: right;
            margin: 0 20px 0 0;
            &_checkbox {
                width: 30%;
            }
        }
    }
    .setting__box {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }
</style>
